import { Card, MEDIA_QUERY, Typography } from '@sky-distribution/react-commons-ui';
import { Tenant, TENANT_NAME } from '../../config/tenants';
import styled from 'styled-components';

const isTenantWithoutCard = TENANT_NAME === Tenant.INTER_RISK || TENANT_NAME === Tenant.TUW;
const isTuw = TENANT_NAME === Tenant.TUW;

export const StyledTitleH1 = styled.h1`
  margin: 0;
  font-size: ${isTuw ? '28px' : 'clamp(1.5rem, 2.5vw, 2.5rem)'};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${({ theme }) => theme.palette.text.header};

  ${MEDIA_QUERY.below('sm')} {
    box-shadow: none;
    width: 100%;
  }
`;

export const CardWrapper = styled.div<{ shadow: boolean; radius: number }>`
  ${
    isTenantWithoutCard
      ? `
      display: flex;
      flex-direction: column;
      width: 100%;
      `
      : `
      ${Card}
      margin: 0 auto;

      ${MEDIA_QUERY.below('sm')} {
        box-shadow: none;
        width: 100%;
        padding: 0.5rem;
      }`
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 1.25rem;

  > form {
    width: 100%;
  }
`;

export const SubmitButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${isTuw ? 'center' : 'stretch'};

  > button {
    ${isTuw ? 'width: clamp(16rem, 42vw, 332px);' : ''}
  }
`;

export const ProgressCircularStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const RequiredText = styled(Typography)`
  color: ${({ theme }) => theme.palette.error.text.base};
  font-weight: normal;
  margin: 0;
  font-size: 0.75rem;
`;

export const TuwDataProcessingText = styled(Typography)`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.paragraph.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;

  a {
    font-weight: 400;
  }
`;
